import { ITranslations } from 'types/common';
import { BrandBasicFormTransFields } from './types';
import en from 'translations/en/brandBasicForm.json';
import pl from 'translations/pl/brandBasicForm.json';
import sl from 'translations/sl/brandBasicForm.json';

export const brandBasicFormTranslations: ITranslations<BrandBasicFormTransFields> = {
  name: 'brandBasicForm',
  en,
  pl,
  sl,
};
